// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._0ZN\\+Wv3uDMtRAGGMyY1yCg\\=\\={overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", "",{"version":3,"sources":["webpack://./src/shared/components/PIEText/PIEText.module.scss"],"names":[],"mappings":"AAEA,8BACI,eAAA,CACA,kBAAA,CACA,sBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_elipsis": "_0ZN+Wv3uDMtRAGGMyY1yCg=="
};
export default ___CSS_LOADER_EXPORT___;
